module.exports = __webpack_public_path__ + "static/media/c12_8.5531f2df.png";